// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/icomoon.eot?rc22sm", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/icomoon.ttf?rc22sm", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/icomoon.woff?rc22sm", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/icomoon.svg?rc22sm", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  font-size: 16px;
}

@font-face {
  font-family: "icomoon";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

[class^="icon-"],
[class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-babyface:before {
  content: "\\e900";
}

.icon-camera:before {
  content: "\\e901";
}

.icon-book:before {
  content: "\\e902";
}

.icon-18 .path1:before {
  content: "\\e903";
  color: #898989;
}

.icon-18 .path2:before {
  content: "\\e904";
  margin-left: -1em;
  color: #f5f8fa;
}

.icon-18 .path3:before {
  content: "\\e905";
  margin-left: -1em;
  color: #898989;
}

.icon-money .path1:before {
  content: "\\e906";
  color: #898989;
}

.icon-money .path2:before {
  content: "\\e907";
  margin-left: -0.884765625em;
  color: white;
}

.icon-money .path3:before {
  content: "\\e908";
  margin-left: -0.884765625em;
  color: white;
}

.icon-hand:before {
  content: "\\e909";
}

.icon-music:before {
  content: "\\e90a";
}

.icon-palette:before {
  content: "\\e90b";
}

.icon-game:before {
  content: "\\e90c";
}

.icon-spider:before {
  content: "\\e90d";
}

.icon-web:before {
  content: "\\e90e";
}

.icon-game {
  font-size: 15px !important;
}

.MuiPopover-root {
  z-index: 99999 !important;
}

.hide {
  display: none !important;
}

.p-0 {
  padding: 0 !important;
}

.YourWrappingContainerClass {
  position: relative;
}

@media (min-width: 768px) {
  .YourWrappingContainerClass {
    width: calc(((100% - 750px) / 2) + 780px) !important;
    margin-right: 0;
  }
  .textright {
    display: flex;
    justify-content: flex-end;
  }
}

@media (min-width: 992px) {
  .YourWrappingContainerClass {
    width: calc(((100% - 970px) / 2) + 1050px) !important;
    margin-right: 0;
  }
}

@media (min-width: 1200px) {
  .YourWrappingContainerClass {
    width: calc(((100% - 1170px) / 2) + 1250px) !important;
    margin-right: 0;
  }
}

.filterIcon {
  position: absolute !important;
}

.filterIcon svg {
  font-size: 31px;
  font-weight: 600;
  color: #176386;
  margin-right: 15px;
}

.filterIcon span {
  font-size: 18px;
  font-weight: 600;
  color: #176386;
}

.posrel {
  position: relative;
}

.clr-gry.slick-arrow {
  top: 0;
  position: absolute;
}

.slick-prev {
  right: -11px;
  top: 50%;
  left: auto;
  z-index: 99;
  opacity: 0;
}

.slick-next {
  right: -11px;
  top: 50%;
  left: auto;
  z-index: 99;
}

.slick-list {
  padding-left: 0px !important;
}

.p-o {
  padding: 0 !important;
}

hr {
  border-color: #3c3c3c;
}

a {
  text-decoration: none;
}

.Header {
  height: 115px;
}

.Header .logoImg {
  height: 90px;
}

.InnerHeader {
  height: 69px;
}

.InnerHeader .logoImg {
  height: 60px;
}

.mainHeading {
  padding: 0 15px;
}

h4.accordianText {
  font-size: 16px;
  font-weight: 400;
}

.br-0 {
  border-radius: 0 !important;
}

.textEllipsys {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre;
}

.d-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.d-flex.justifyEnd {
  justify-content: flex-end;
}

.d-flex.flexStart {
  justify-content: flex-start;
}

.width100 {
  width: 100%;
}

.slick-dots {
  text-align: end;
}

.slick-dots li {
  margin: 0;
  width: 15px;
}

.slick-dots li button:before {
  color: #176386;
  font-size: 10px;
}

.slick-dots li.slick-active button:before {
  color: #3e37a2 !important;
  font-size: 10px;
}

.favourites {
  background-color: white;
  border-radius: 5px;
  position: relative;
  padding: 38px 15px 15px;
}

.favourites .Ticker {
  top: 52px;
  right: 14px;
}

.favourites:hover {
  box-shadow: rgba(14, 14, 14, 0.25) 0px 0px 8px 0px;
  transition: all 0.1s ease 0s;
  transform: translateY(-2px);
}

.maincolor {
  color: 14bbf5 !important;
}

.bgcolor {
  background: #14bbf5 !important;
}

.bgblack {
  background-color: #000 !important;
}

.bgCardcolor {
  position: relative;
  color: #f5f5f5;
  border-radius: 0.25rem !important;
  transition: all 0.4s ease-in-out 0s;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.bgCardcolor:hover {
  transform: scale(1.021);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
  transition: all 0.4s ease-in-out 0s;
  border-radius: 15px !important;
}

.bgCardcolor .bgCardcolor_main {
  width: 100%;
}

body {
  margin: 0;
  padding: 0;
  background: #fff;
  color: #52565c;
  font-family: "Poppins", sans-serif;
  overflow-x: hidden;
}

.Ticker {
  position: absolute;
  top: 20px;
  padding: 8px 16px;
  border-radius: 5px 0 0 5px;
  right: 0px;
  color: #fff;
  display: block;
  background: #14bbf5 !important;
}

.Ticker h5 {
  font-size: 13px;
  margin-bottom: 0 !important;
  line-height: 18px;
}

label {
  display: inline;
  padding: 2em 0em 0.7em;
  font-weight: 500;
  font-size: 14px;
  line-height: 27px;
  color: #707070;
  display: block;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25em;
}

.label-warning {
  background-color: #f0ad4e;
}

.label-warning[href]:focus,
.label-warning[href]:hover {
  background-color: #ec971f;
}

.label-danger {
  background-color: #d9534f;
}

.label-danger[href]:focus,
.label-danger[href]:hover {
  background-color: #21c21b;
}

.label-success {
  background-color: #21c21b;
}

.label-success[href]:focus,
.label-success[href]:hover {
  background-color: #21c21b;
}

figure {
  margin: 0;
}

.usersView {
  margin-bottom: 15px;
  position: relative;
}

.usersView .figure {
  margin-top: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.usersView .figure.justify-center {
  justify-content: center;
}

.usersView .figure.justify-flex-start {
  justify-content: flex-start;
}

.usersView .figure.align-flex-start {
  align-items: flex-start;
}

.usersView .figure.profilePicture img {
  min-width: 800px;
  width: 100%;
}

.usersView .figure img {
  width: 100%;
}

.usersView .usersPic {
  position: relative;
  margin-top: -80px;
  left: 50%;
  transform: translateX(-50%);
}

.usersView .usersPic figure {
  border-radius: 50%;
  border: 2px solid #f1f1f1;
  width: 150px;
  height: 150px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0px auto 13px;
}

.usersView .usersPic figure.justify-center {
  justify-content: center;
}

.usersView .usersPic figure.justify-flex-start {
  justify-content: flex-start;
}

.usersView .usersPic figure.align-flex-start {
  align-items: flex-start;
}

.usersView .usersPic figure img.check_icon {
  position: absolute;
  width: auto !important;
  height: auto !important;
  right: 20px;
  top: 4px;
}

.usersView .usersPic figure img {
  width: 100%;
}

.userDetails {
  text-align: center;
  background: #fff;
  border-radius: 7px;
}

.userDetails h4 {
  color: #000;
  margin-bottom: 20px !important;
}

.userDetails h6 {
  color: #0d8ccd;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
}

.userDetails .tokenAddress {
  border: 1px solid #e9e9e9;
  box-sizing: border-box;
  border-radius: 15px;
  padding: 2px 10px;
  font-size: 15px;
  line-height: 22px;
  color: #898989;
  margin-left: 10px;
}

.userPic {
  margin-top: -60px;
  z-index: 99;
  position: relative;
  background: #fff;
  border-radius: 7px;
  box-shadow: 0 11px 24px rgba(0, 0, 0, 0.12);
  padding: 11px;
}

.userPic figure {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 7px;
  height: 180px;
  width: 100%;
  position: relative;
}

.userPic figure img {
  position: absolute;
  top: 50%;
  left: 50%;
  max-width: 100%;
  width: 100%;
  transform: translate(-50%, -50%);
  box-shadow: 0 11px 24px rgba(0, 0, 0, 0.12);
  border-radius: 7px;
}

.socialLink {
  display: flex;
  align-items: center;
  justify-content: space-between;
  justify-content: center;
}

.socialLink.justify-center {
  justify-content: center;
}

.socialLink.justify-flex-start {
  justify-content: flex-start;
}

.socialLink.align-flex-start {
  align-items: flex-start;
}

.socialLink a {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #000;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  justify-content: center;
}

.socialLink a.justify-center {
  justify-content: center;
}

.socialLink a.justify-flex-start {
  justify-content: flex-start;
}

.socialLink a.align-flex-start {
  align-items: flex-start;
}

.socialLink svg {
  font-size: 22px;
  margin-right: 10px;
  margin-left: 15px;
}

.listingFooter li {
  padding: 5px 0;
}

.listingFooter li a {
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  cursor: pointer;
}

.listingFooter li a:hover {
  text-decoration: none;
}

.media_links {
  padding: 0;
  margin: 0;
}

.media_links li {
  padding: 0;
  margin-bottom: 20px;
}

.media_links li a {
  margin-right: 20px;
}

.media_links li a svg {
  font-size: 22px;
}

.uploadBox {
  background: #ffffff;
  border: 1px dashed #898989;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 132px;
  flex-direction: column;
  padding: 45px 25px;
}

.uploadBox.justify-center {
  justify-content: center;
}

.uploadBox.justify-flex-start {
  justify-content: flex-start;
}

.uploadBox.align-flex-start {
  align-items: flex-start;
}

.uploadBox h6 {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

.uploadBox p {
  font-style: normal;
  font-weight: 400;
  font-size: 14px !important;
  line-height: 21px !important;
}

.setPrice {
  background: #ffffff;
  border: 1px solid #898989;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
  border-radius: 25px;
  height: 150px;
  width: 150px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  justify-content: center;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
  cursor: pointer;
}

.setPrice.justify-center {
  justify-content: center;
}

.setPrice.justify-flex-start {
  justify-content: flex-start;
}

.setPrice.align-flex-start {
  align-items: flex-start;
}

.setPrice svg {
  font-size: 35px;
  margin-bottom: 8px;
}

.setPrice img {
  width: 35px;
  margin-bottom: 8px;
}

.setPrice.active {
  border: 1px solid #039be3;
  color: #039be3;
}

.setPrice p {
  font-style: normal;
  font-weight: 400;
  font-size: 14px !important;
  line-height: 21px !important;
  color: #898989;
}

small {
  font-style: normal;
  font-weight: 400;
  font-size: 14px !important;
  line-height: 21px !important;
  margin-top: 10px;
  color: #898989;
  font-weight: 400;
  display: block;
}

small span {
  color: #0f8aca;
}

img {
  image-rendering: -webkit-optimize-contrast;
}

.preiewBox {
  background: #ffffff;
  border: 1px solid #898989;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
  border-radius: 25px;
  height: 470px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  justify-content: center;
}

.preiewBox.justify-center {
  justify-content: center;
}

.preiewBox.justify-flex-start {
  justify-content: flex-start;
}

.preiewBox.align-flex-start {
  align-items: flex-start;
}

.extraHeader {
  max-width: 600px;
  margin: 0 auto;
}

.extraHeader h4 {
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  line-height: 39px;
  color: #000;
}

.extraHeader p {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #898989;
  margin-bottom: 25px;
}

.extraHeader p span {
  color: #0d8ccd;
  display: block;
}

.connectWallet {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  box-sizing: border-box;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
  border-radius: 25px;
  padding: 10px 25px;
  min-height: 140px;
}

.connectWallet.justify-center {
  justify-content: center;
}

.connectWallet.justify-flex-start {
  justify-content: flex-start;
}

.connectWallet.align-flex-start {
  align-items: flex-start;
}

.connectWallet h4 {
  margin-bottom: 0;
  font-size: 22px;
  line-height: 36px;
  font-weight: 500;
  color: #898989;
}

.lowerHeader h3 {
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  text-align: center;
  color: #000000;
}

.lowerHeader p {
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;
  text-align: center;
  margin-top: 20px;
  color: #898989;
}

.faqHeader {
  font-weight: 600;
  font-size: 26px;
  line-height: 39px;
  color: #0d8ccd;
}

p.MuiFormHelperText-root.MuiFormHelperText-contained.Mui-error {
  margin-left: 0px;
}

@media (max-width: 767px) {
  .connectWallet {
    display: block;
    text-align: center;
  }
  .connectWallet h4 {
    font-size: 17px;
    line-height: 26px;
    margin-bottom: 15px;
  }
}

.nftData {
  margin-top: 10px !important;
  display: block;
  font-style: normal;
  font-weight: 400;
  font-size: 14px !important;
  line-height: 21px !important;
  color: #898989;
}

.nftData span {
  color: #000;
}

.nftData span.blue {
  color: #039be3;
}

.roundBox {
  margin-right: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 2px solid #bdbcbc;
  box-sizing: border-box;
  border-radius: 50px;
  padding: 4px 12px;
}

.roundBox.justify-center {
  justify-content: center;
}

.roundBox.justify-flex-start {
  justify-content: flex-start;
}

.roundBox.align-flex-start {
  align-items: flex-start;
}

.roundBox svg {
  font-size: 18px;
}

.roundBox h5 {
  margin-left: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #3d3d3d;
}

.smallfont {
  font-style: normal;
  font-weight: 400;
  font-size: 14px !important;
  line-height: 21px !important;
  color: #898989 !important;
  font-weight: 300 !important;
}

.creatorButton {
  border: 2px solid #039be3;
  box-sizing: border-box;
  border-radius: 50px;
  padding: 7px 29px;
  display: inline-block;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #000;
}

.creatorButton span {
  color: #039be3;
}

.mb-10 {
  margin-bottom: 10px !important;
}

.ml-10 {
  margin-left: 10px !important;
}

.p.MuiFormHelperText-root.MuiFormHelperText-contained.Mui-error {
  margin-left: 0px !important;
}

.MuiInputBase-inputMultiline {
  height: 22px;
  padding: 0;
}

.jodit-react-container {
  width: 100%;
}

.btnWidth {
  width: 300px !important;
  max-width: 100% !important;
}

.btn-block {
  width: 100% !important;
}

.Logocenter {
  text-align: center;
}

.topmenu {
  border-bottom: solid 2px #8d00f2;
}

.btnHight {
  height: 35px;
  font-size: 12px !important;
  margin-top: 16px !important;
}

.removeredius {
  width: 150px;
  border-radius: 0 !important;
  max-width: 100%;
}

.tokenList {
  display: flex;
  flex-wrap: wrap;
}

.tokenList li {
  color: #141518;
  width: 103px;
  border: solid 0.5px #e5e3dd;
  margin: 0px 5px;
  display: flex;
  padding: 5px;
  position: relative;
  font-size: 10px;
  text-align: center;
  justify-content: center;
  background-color: #fff;
}

.tokenList li svg {
  color: #60be60;
  right: 0;
  bottom: 0px;
  position: absolute;
  font-size: 20px;
}

.tokenList li img {
  width: 30px;
}

.chat-Box {
  border: solid 0.5px #e5e3dd;
  padding: 15px;
  height: 65vh;
  overflow-y: scroll;
}

.chat-Box .right-Box {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 25px;
}

.chat-Box .right-Box div {
  position: relative;
  border-radius: 9px;
  background-image: linear-gradient(to bottom, #c04848, #480048);
  padding: 15px;
  max-width: 500px;
  min-width: 100px;
  font-size: 15px;
  color: #fff;
}

.chat-Box .right-Box div span {
  position: absolute;
  font-size: 11px;
  color: #000;
  right: 0;
  bottom: -25px;
}

.chat-Box .left-Box {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 25px;
}

.chat-Box .left-Box div {
  position: relative;
  border-radius: 9px;
  box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
  padding: 15px;
  max-width: 500px;
  min-width: 100px;
  font-size: 15px;
  color: #707070;
}

.chat-Box .left-Box div span {
  position: absolute;
  font-size: 11px;
  color: #000;
  right: 0;
  bottom: -25px;
}

.userimg {
  width: 100px;
  height: 100px;
  margin: auto;
  border-radius: 50%;
}

.p.MuiFormHelperText-root.MuiFormHelperText-contained.Mui-error {
  margin-left: 0px !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

@media (max-width: 1640px) {
  .tokenList li {
    width: 101px;
  }
}

@media (max-width: 1440px) {
  .tokenList li {
    width: 85px;
  }
}

@media (max-width: 1366px) {
  .tokenList li {
    width: 80px;
  }
}

@media (max-width: 1280px) {
  .tokenList li {
    width: 75px;
  }
}

@media (max-width: 1024px) {
  .tokenList li {
    width: 75px;
    margin-bottom: 5px;
  }
}

@media (max-width: 767px) {
  .tokenList li {
    width: 67px;
  }
  .imgWidth {
    max-width: 100%;
  }
}

.MuiFormHelperText-contained {
  margin-left: 0px;
  margin-right: 14px;
}

.m-t-0 {
  margin-top: 0px !important;
}

.m-0 {
  margin: 0px !important;
}

.p-t-0 {
  padding-top: 0px !important;
}

.p-0 {
  padding: 0px !important;
}

.m-b-0 {
  margin-bottom: 0px !important;
}

.m-0 {
  margin: 0px !important;
}

.p-b-0 {
  padding-bottom: 0px !important;
}

.p-0 {
  padding: 0px !important;
}

.m-l-0 {
  margin-left: 0px !important;
}

.m-0 {
  margin: 0px !important;
}

.p-l-0 {
  padding-left: 0px !important;
}

.p-0 {
  padding: 0px !important;
}

.m-r-0 {
  margin-right: 0px !important;
}

.m-0 {
  margin: 0px !important;
}

.p-r-0 {
  padding-right: 0px !important;
}

.p-0 {
  padding: 0px !important;
}

.m-t-5 {
  margin-top: 5px !important;
}

.m-5 {
  margin: 5px !important;
}

.p-t-5 {
  padding-top: 5px !important;
}

.p-5 {
  padding: 5px !important;
}

.m-b-5 {
  margin-bottom: 5px !important;
}

.m-5 {
  margin: 5px !important;
}

.p-b-5 {
  padding-bottom: 5px !important;
}

.p-5 {
  padding: 5px !important;
}

.m-l-5 {
  margin-left: 5px !important;
}

.m-5 {
  margin: 5px !important;
}

.p-l-5 {
  padding-left: 5px !important;
}

.p-5 {
  padding: 5px !important;
}

.m-r-5 {
  margin-right: 5px !important;
}

.m-5 {
  margin: 5px !important;
}

.p-r-5 {
  padding-right: 5px !important;
}

.p-5 {
  padding: 5px !important;
}

.m-t-10 {
  margin-top: 10px !important;
}

.m-10 {
  margin: 10px !important;
}

.p-t-10 {
  padding-top: 10px !important;
}

.p-10 {
  padding: 10px !important;
}

.m-b-10 {
  margin-bottom: 10px !important;
}

.m-10 {
  margin: 10px !important;
}

.p-b-10 {
  padding-bottom: 10px !important;
}

.p-10 {
  padding: 10px !important;
}

.m-l-10 {
  margin-left: 10px !important;
}

.m-10 {
  margin: 10px !important;
}

.p-l-10 {
  padding-left: 10px !important;
}

.p-10 {
  padding: 10px !important;
}

.m-r-10 {
  margin-right: 10px !important;
}

.m-10 {
  margin: 10px !important;
}

.p-r-10 {
  padding-right: 10px !important;
}

.p-10 {
  padding: 10px !important;
}

.m-t-15 {
  margin-top: 15px !important;
}

.m-15 {
  margin: 15px !important;
}

.p-t-15 {
  padding-top: 15px !important;
}

.p-15 {
  padding: 15px !important;
}

.m-b-15 {
  margin-bottom: 15px !important;
}

.m-15 {
  margin: 15px !important;
}

.p-b-15 {
  padding-bottom: 15px !important;
}

.p-15 {
  padding: 15px !important;
}

.m-l-15 {
  margin-left: 15px !important;
}

.m-15 {
  margin: 15px !important;
}

.p-l-15 {
  padding-left: 15px !important;
}

.p-15 {
  padding: 15px !important;
}

.m-r-15 {
  margin-right: 15px !important;
}

.m-15 {
  margin: 15px !important;
}

.p-r-15 {
  padding-right: 15px !important;
}

.p-15 {
  padding: 15px !important;
}

.m-t-20 {
  margin-top: 20px !important;
}

.m-20 {
  margin: 20px !important;
}

.p-t-20 {
  padding-top: 20px !important;
}

.p-20 {
  padding: 20px !important;
}

.m-b-20 {
  margin-bottom: 20px !important;
}

.m-20 {
  margin: 20px !important;
}

.p-b-20 {
  padding-bottom: 20px !important;
}

.p-20 {
  padding: 20px !important;
}

.m-l-20 {
  margin-left: 20px !important;
}

.m-20 {
  margin: 20px !important;
}

.p-l-20 {
  padding-left: 20px !important;
}

.p-20 {
  padding: 20px !important;
}

.m-r-20 {
  margin-right: 20px !important;
}

.m-20 {
  margin: 20px !important;
}

.p-r-20 {
  padding-right: 20px !important;
}

.p-20 {
  padding: 20px !important;
}

.m-t-25 {
  margin-top: 25px !important;
}

.m-25 {
  margin: 25px !important;
}

.p-t-25 {
  padding-top: 25px !important;
}

.p-25 {
  padding: 25px !important;
}

.m-b-25 {
  margin-bottom: 25px !important;
}

.m-25 {
  margin: 25px !important;
}

.p-b-25 {
  padding-bottom: 25px !important;
}

.p-25 {
  padding: 25px !important;
}

.m-l-25 {
  margin-left: 25px !important;
}

.m-25 {
  margin: 25px !important;
}

.p-l-25 {
  padding-left: 25px !important;
}

.p-25 {
  padding: 25px !important;
}

.m-r-25 {
  margin-right: 25px !important;
}

.m-25 {
  margin: 25px !important;
}

.p-r-25 {
  padding-right: 25px !important;
}

.p-25 {
  padding: 25px !important;
}

.m-t-30 {
  margin-top: 30px !important;
}

.m-30 {
  margin: 30px !important;
}

.p-t-30 {
  padding-top: 30px !important;
}

.p-30 {
  padding: 30px !important;
}

.m-b-30 {
  margin-bottom: 30px !important;
}

.m-30 {
  margin: 30px !important;
}

.p-b-30 {
  padding-bottom: 30px !important;
}

.p-30 {
  padding: 30px !important;
}

.m-l-30 {
  margin-left: 30px !important;
}

.m-30 {
  margin: 30px !important;
}

.p-l-30 {
  padding-left: 30px !important;
}

.p-30 {
  padding: 30px !important;
}

.m-r-30 {
  margin-right: 30px !important;
}

.m-30 {
  margin: 30px !important;
}

.p-r-30 {
  padding-right: 30px !important;
}

.p-30 {
  padding: 30px !important;
}

.m-t-35 {
  margin-top: 35px !important;
}

.m-35 {
  margin: 35px !important;
}

.p-t-35 {
  padding-top: 35px !important;
}

.p-35 {
  padding: 35px !important;
}

.m-b-35 {
  margin-bottom: 35px !important;
}

.m-35 {
  margin: 35px !important;
}

.p-b-35 {
  padding-bottom: 35px !important;
}

.p-35 {
  padding: 35px !important;
}

.m-l-35 {
  margin-left: 35px !important;
}

.m-35 {
  margin: 35px !important;
}

.p-l-35 {
  padding-left: 35px !important;
}

.p-35 {
  padding: 35px !important;
}

.m-r-35 {
  margin-right: 35px !important;
}

.m-35 {
  margin: 35px !important;
}

.p-r-35 {
  padding-right: 35px !important;
}

.p-35 {
  padding: 35px !important;
}

.m-t-40 {
  margin-top: 40px !important;
}

.m-40 {
  margin: 40px !important;
}

.p-t-40 {
  padding-top: 40px !important;
}

.p-40 {
  padding: 40px !important;
}

.m-b-40 {
  margin-bottom: 40px !important;
}

.m-40 {
  margin: 40px !important;
}

.p-b-40 {
  padding-bottom: 40px !important;
}

.p-40 {
  padding: 40px !important;
}

.m-l-40 {
  margin-left: 40px !important;
}

.m-40 {
  margin: 40px !important;
}

.p-l-40 {
  padding-left: 40px !important;
}

.p-40 {
  padding: 40px !important;
}

.m-r-40 {
  margin-right: 40px !important;
}

.m-40 {
  margin: 40px !important;
}

.p-r-40 {
  padding-right: 40px !important;
}

.p-40 {
  padding: 40px !important;
}

.m-t-45 {
  margin-top: 45px !important;
}

.m-45 {
  margin: 45px !important;
}

.p-t-45 {
  padding-top: 45px !important;
}

.p-45 {
  padding: 45px !important;
}

.m-b-45 {
  margin-bottom: 45px !important;
}

.m-45 {
  margin: 45px !important;
}

.p-b-45 {
  padding-bottom: 45px !important;
}

.p-45 {
  padding: 45px !important;
}

.m-l-45 {
  margin-left: 45px !important;
}

.m-45 {
  margin: 45px !important;
}

.p-l-45 {
  padding-left: 45px !important;
}

.p-45 {
  padding: 45px !important;
}

.m-r-45 {
  margin-right: 45px !important;
}

.m-45 {
  margin: 45px !important;
}

.p-r-45 {
  padding-right: 45px !important;
}

.p-45 {
  padding: 45px !important;
}

.m-t-50 {
  margin-top: 50px !important;
}

.m-50 {
  margin: 50px !important;
}

.p-t-50 {
  padding-top: 50px !important;
}

.p-50 {
  padding: 50px !important;
}

.m-b-50 {
  margin-bottom: 50px !important;
}

.m-50 {
  margin: 50px !important;
}

.p-b-50 {
  padding-bottom: 50px !important;
}

.p-50 {
  padding: 50px !important;
}

.m-l-50 {
  margin-left: 50px !important;
}

.m-50 {
  margin: 50px !important;
}

.p-l-50 {
  padding-left: 50px !important;
}

.p-50 {
  padding: 50px !important;
}

.m-r-50 {
  margin-right: 50px !important;
}

.m-50 {
  margin: 50px !important;
}

.p-r-50 {
  padding-right: 50px !important;
}

.p-50 {
  padding: 50px !important;
}
`, "",{"version":3,"sources":["webpack://./src/scss/_base.scss","webpack://./src/scss/main.css","webpack://./src/scss/_breed.scss","webpack://./src/scss/_responsive.scss","webpack://./src/scss/_spacing-helpers.scss"],"names":[],"mappings":"AAAA;EACE,eAAe;ACCjB;;ADMA;EACE,sBAAsB;EACtB,4CAAoC;EACpC,mPAG+C;EAC/C,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;ACNrB;;AAEA;;EDSE,+EAAA;EACA,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EAEd,sCAAA;EACA,mCAAmC;EACnC,kCAAkC;ACPpC;;ADUA;EACE,gBAAgB;ACPlB;;ADSA;EACE,gBAAgB;ACNlB;;ADQA;EACE,gBAAgB;ACLlB;;ADOA;EACE,gBAAgB;EAChB,cAAyB;ACJ3B;;ADMA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAyB;ACH3B;;ADKA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAyB;ACF3B;;ADIA;EACE,gBAAgB;EAChB,cAAyB;ACD3B;;ADGA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,YAAyB;ACA3B;;ADEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,YAAyB;ACC3B;;ADCA;EACE,gBAAgB;ACElB;;ADAA;EACE,gBAAgB;ACGlB;;ADDA;EACE,gBAAgB;ACIlB;;ADFA;EACE,gBAAgB;ACKlB;;ADHA;EACE,gBAAgB;ACMlB;;ADJA;EACE,gBAAgB;ACOlB;;ADLA;EACE,0BAA0B;ACQ5B;;ADNA;EACE,yBAAyB;ACS3B;;ADPA;EACE,wBAAwB;ACU1B;;ADRA;EACE,qBAAqB;ACWvB;;ADNA;EACE,kBAAkB;ACSpB;;ADPA;EACE;IACE,oDAAoD;IACpD,eAAe;ECUjB;EDRA;IAGC,aAAA;IAcK,yBAAgB;EACtB;ACDF;;AAEA;EACE;IACE,qDAAqD;IDGzD,eAAmB;EACjB;ACDF;;AAEA;EACE;IACE,sDAAsD;IDO1D,eAAY;EACV;ACLF;;ADIA;EAGI,6BAAe;ACHnB;;AAEA;EDKG,eAAA;ECHD,gBAAgB;EDJlB,cAQM;EACF,kBAAe;ACFnB;;AAEA;EACE,eAAe;EDIjB,gBAAQ;EACN,cAAU;ACFZ;;ADOA;EACE,kBAAM;ACJR;;AAEA;EDKA,MAAA;EACE,kBAAY;ACHd;;AAEA;EDKE,YAAU;EACX,QAAA;ECHC,UAAU;EDKZ,WAAY;EACV,UAAO;ACHT;;AAEA;EDKC,YAAA;ECHC,QAAQ;EDIV,UAAY;EACV,WAAA;ACFF;;ADIA;EACE,4BAAqB;ACDvB;;ADGA;EACE,qBAAqB;ACAvB;;ADEA;EACE,qBAAqB;ACCvB;;ADCA;EACE,qBAAa;ACEf;;ADHA;EAGI,aAAY;ACIhB;;ADDA;EACE,YAAY;ACId;;ADLA;EAGI,YAAY;ACMhB;;ADHA;EACE,YAAS;ACMX;;ADJA;EACE,eAAe;ACOjB;;AAEA;EDNA,eAAM;EACJ,gBAAe;ACQjB;;ADNA;EACE,2BAAgB;ACSlB;;AAEA;EACE,gBAAgB;EDRlB,uBAAQ;EACN,gBAAa;ACUf;;AAEA;EDRI,aAAA;EALG,uBAOO;ECeJ,mBAAmB;ADX7B;;ACcA;EDVE,yBAAe;ACcjB;;ADZA;EAGC,2BAAA;ACeD;;AAEA;EDdE,WAAW;ACgBb;;ADbA;EACE,eAAO;ACgBT;;AAEA;EDfA,SAAW;EACT,WAAA;ACiBF;;AAEA;EDLC,cAAA;ECOC,eAAe;ADtBjB;;ACyBA;EDhBG,yBAAA;ECkBD,eAAe;AD3BjB;;AC8BA;EDjBI,uBAAW;EACZ,kBAAA;ECmBD,kBAAkB;EDLpB,uBAAW;ACOX;;AAEA;EDNA,SAAS;EAZP,WAAU;ACqBZ;;ADNA;EAEC,kDAAA;EACD,4BAAa;EAEJ,2BAAO;ACUhB;;AAEA;EDRE,wBAAuB;ACUzB;;ADhBA;EAQI,8BAAuB;ACY3B;;AAEA;EDVG,iCAAA;ACYH;;AAEA;EDXG,kBAAA;ECaD,cAAc;EDKhB,iCAAK;EAEH,mCAAU;EACV,4BAAgB;EAChB,6BAAc;ACHhB;;AAEA;EDMQ,uBAAA;EAED,2CAAI;EAET,mCAA0B;EAC1B,8BAAU;ACHZ;;AAEA;EDUC,WAAA;ACRD;;AAEA;EDGI,SAAA;EACA,UAAA;EACD,gBAAA;ECDD,cAAc;EDIhB,kCAAM;EACJ,kBAAe;ACFjB;;AAEA;EDIE,kBAAiB;EACjB,SAAO;EACP,iBAAc;EACd,0BAAmB;EACnB,UAAA;EACA,WAAA;EACD,cAAA;ECFC,8BAA8B;ADShC;;ACNA;EACE,eAAe;EDQjB,2BAA0B;EAC1B,iBAAe;ACNf;;AAEA;EDOA,eAAc;EACZ,sBAAkB;EACnB,gBAAA;ECLC,eAAe;EDMjB,iBAAmB;EACnB,cAAa;EACX,cAAA;EACD,mBAAA;ECJC,wBAAwB;EDK1B,qBAAe;ACHf;;AAEA;EDIA,yBAA0B;AAC1B;;ACDA;;EDKA,yBAAO;ACFP;;AAEA;EDGA,yBAAW;ACDX;;AAEA;;EDDA,yBAGU;ACCV;;AAEA;EDtFE,yBAAiB;ACwFnB;;AAEA;;EDxFI,yBAAuB;AC2F3B;;ADzFE;EACE,SAAA;AC4FJ;;AD1FE;EACE,mBAAa;EACd,kBAAA;AC6FH;;AAEA;EDbQ,gBAAW;EAXnB,aAGE;EC4BQ,mBAAmB;EDXzB,8BAAiB;EACjB,kBAAS;ACeb;;AAEA;EDbc,uBAAiB;ACiB/B;;AAEA;ED5HE,2BAA8B;ACgIhC;;AAEA;ED/HG,uBAAA;ACmIH;;AAEA;EDlIG,gBAAA;ECoID,WAAW;ADnIX;;ACsIF;EACE,WAAW;AD9Db;;ACiEA;ED9BQ,kBAAQ;EACR,iBAAW;EACX,SAAQ;ECiCN,2BAA2B;ADtErC;;ACyEA;EACE,kBAAkB;ED7BpB,yBAAa;EACX,YAAY;EACZ,aAAY;EACZ,kBAAkB;EAHpB,aAII;EAGD,mBAAA;EAEQ,8BAAO;EAxUhB,qBAAkB;AC2WpB;;AAEA;EAGU,uBAAuB;ADjDjC;;ACoDA;EDlCI,2BAAe;ACsCnB;;AAEA;EDlCS,uBAAA;ACsCT;;AAEA;EDpCE,kBAAgB;EAChB,sBAAkB;EA5WlB,uBAAuB;EA8WvB,WAAS;EAqBV,QAAA;ACkBD;;AAEA;EDtCI,WAAA;ACwCJ;;AAEA;EDtCI,kBAAa;EACb,gBAAW;EACX,kBAAkB;ACwCtB;;ADxDA;EAkBM,WAAU;EACV,8BAAQ;AC0Cd;;AAEA;EDxCM,cAAW;EA9Xf,kBAAkB;EAgYd,gBAAe;EAChB,eAAA;EC0CH,iBAAiB;EDvCnB,gBAAY;ACyCZ;;AAEA;EDzCE,yBAAuB;EC4Cf,sBAAsB;ED/N9B,mBAAC;EACC,iBAAiB;EAClB,eAAA;ECiOD,iBAAiB;EDhOjB,cAAC;EACC,iBAAiB;ACkOrB;;ADhOE;EACE,iBAAa;EACd,WAAA;ECmOD,kBAAkB;ED1DpB,gBAGI;EAvXF,kBAAkB;EAElB,2CAAe;EACf,aAAa;ACibf;;AAEA;ED1DI,aAAA;EAzLF,uBAAiB;EC4PT,mBAAmB;EDzP3B,gBAAC;EACC,kBAAiB;EAClB,aAAA;EC2PD,WAAW;ED1PX,kBAAC;AC4PH;;AAEA;EDnFA,kBAUM;EACF,QAAA;EACA,SAAA;EACA,eAAa;EACd,WAAA;EAEH,gCACK;EAWF,2CAAA;ECiED,kBAAkB;AD7EpB;;ACgFA;EDrEK,aAAA;EAFG,mBAAqB;EAK7B,8BAAa;EAaZ,uBAAA;ACkED;;AAEA;EAGU,uBAAuB;ADpFjC;;ACuFA;ED9EQ,2BAAe;ACkFvB;;AD7EA;EAGE,uBAAwB;ACgF1B;;AAEA;EDnTE,kBAAiB;EAoOjB,gBAAa;EACb,eAAc;EACd,iBAAS;EAOV,WAAA;EC4EC,gBAAgB;EDtTf,aAAA;EAEC,mBAA2B;EAE5B,8BAAkB;EC8TX,uBAAuB;ADvGjC;;AC0GA;ED/FG,uBAAA;ACmGH;;AAEA;EDvgBE,2BAA4B;AC2gB9B;;ADpGA;EAGE,uBAAwB;ACuG1B;;AAEA;ED5VE,eAAa;EACb,kBAAa;EACb,iBAAiB;AC8VnB;;AAEA;EDjiBE,cAAa;ACmiBf;;AAEA;ED1GE,gBAAe;EAiBhB,eAAA;EC4FC,iBAAiB;EDtWjB,eAAC;ACwWH;;AAEA;EDvWE,qBAAC;ACyWH;;AAEA;EDxWE,UAAC;EACC,SAAA;AC0WJ;;ADpIA;EAcI,UAAS;EACT,mBAAkB;AC0HtB;;ADzIA;EAkBI,kBAAW;AC2Hf;;AAEA;ED/IA,eAqBW;AC4HX;;AAEA;EACE,mBAAmB;EDpJrB,0BAyBI;EAlcF,2CAAgB;EAChB,mBAAW;EAocV,aAAA;EAtcD,mBAAkB;EAGlB,8BAA4B;EAuc5B,aAAY;EAOb,sBAAA;ECgIC,kBAAkB;ADzIpB;;AC4IA;EDjIE,uBAAiB;ACqInB;;ADnIA;EAGE,2BAAwB;ACsI1B;;AAEA;EDpIE,uBAAsB;ACwIxB;;AAEA;EDzaE,kBAAC;EACC,gBAAe;EAChB,eAAA;EC2aD,iBAAiB;AD1ajB;;AC6aF;EACE,kBAAkB;ED3alB,gBAAC;EACC,0BAAuB;EACxB,4BAAA;AC6aH;;AAEA;EDnJE,mBAAc;EAiBf,yBAAA;EAnBD,2CAGK;EACD,mBAAkB;EAClB,aAAa;EACb,YAAW;EAGZ,aAAA;EA9eD,mBAAkB;EAGlB,8BAAiB;EC2oBT,sBAAsB;EDzJnB,uBAAO;EACf,kBAAA;EC6JH,gBAAgB;ED1JlB,eAAe;EAzTb,iBAAa;EACb,cAAa;EACb,eAAe;ACsdjB;;AAEA;ED1JS,uBAAW;AC8JpB;;AAEA;ED3dG,2BAAA;AC+dH;;AAEA;ED7dE,uBAAmB;ACierB;;AAEA;EDnLA,eASI;EACA,kBAAgB;AC4KpB;;AAEA;ED1KI,WAAO;EACR,kBAAA;AC4KH;;AAEA;EDzKI,yBAAe;EACf,cAAa;AC2KjB;;AAEA;EACE,kBAAkB;EDlLpB,gBAQI;EACA,0BAAgB;EAChB,4BAAe;EACf,cAAa;AC4KjB;;AAEA;ED1KG,kBAAA;EC4KD,gBAAgB;ED1KlB,0BAAW;EACT,4BAAgB;EAChB,gBAAe;EACf,cAAa;EAEb,gBAAc;EACf,cAAA;AC2KD;;AAEA;ED1KC,cAAA;AC4KD;;AAEA;EACE,0CD3KgB;AC4KlB;;AAEA;EACE,mBD5KmB;EC6KnB,yBD5KqB;EAElB,2CAAA;EC6KH,mBAAmB;EACnB,aAAa;EDzKb,aAAS;EA3iBT,mBAA0B;EAojB3B,8BAAA;EAJE,sBAAA;EAEQ,uBAAO;ACmLlB;;ADhLA;EA5XE,uBAAmB;ACkjBrB;;AAEA;EDzKC,2BAAA;AC6KD;;AAEA;EDrjBG,uBAAoB;ACyjBvB;;AAEA;EDxjBE,gBAAC;EACC,cAAa;AC0jBjB;;ADvMA;EAQI,kBAAe;EAChB,gBAAA;ECmMD,eAAe;ED5MjB,iBAUK;EACD,WAAW;ACoMf;;AAEA;ED3wBE,kBAAiB;EAukBf,gBAAc;EACf,eAAA;ECuMD,iBAAiB;EDrMnB,cAAW;EAvkBT,mBAAkB;AC+wBpB;;AAEA;EDxME,cAAO;EACP,cAAa;AC0Mf;;ADxMA;EAGE,aAAa;EArlBb,mBAAkB;EAGlB,8BAAiB;EAulBjB,mBAAW;EAIZ,yBAAA;EAZD,sBASO;EAEJ,2CAAA;EC+MD,mBAAmB;ED5MrB,kBAAO;EACL,iBAAe;AC8MjB;;AD5MA;ECiNU,uBAAuB;AD9MjC;;ACiNA;ED7MU,2BAAI;ACiNd;;AAEA;ED5ME,uBAAyB;ACgN3B;;AD9MA;EACE,gBACF;EAAC,eAAA;ECiNC,iBAAiB;EC97BnB,gBAAU;EACR,cAAO;ADg8BT;;AAEA;EC/7BA,gBAAW;EACT,eAAO;EACR,iBAAA;EDi8BC,kBAAkB;ECh8BpB,cAAY;ADk8BZ;;AAEA;ECj8BA,gBAAS;EACP,eAAe;EAChB,iBAAA;EDm8BC,kBAAkB;ECl8BpB,gBAAU;EACR,cAAY;ADo8Bd;;AAEA;EACE,gBAAgB;ECl8BlB,eAAc;EACZ,iBAAY;EACZ,cAAa;ADo8Bf;;AAEA;ECl8BA,gBAAW;ADo8BX;;AAEA;EACE;ICv8BF,cAGK;IACD,kBAAc;EACd;EACA;IACA,eAAe;IACf,iBAAa;IACb,mBAAY;EACZ;ADs8BJ;;AAEA;ECp8BI,2BAAsB;EAYvB,cAAA;ED27BD,kBAAkB;ECr9BpB,gBAgBQ;EACF,0BAAc;EACd,4BAAQ;EACR,cAAW;ADu8BjB;;AAEA;EACE,WAAW;AC79Bb;;ADg+BA;EACE,cAAc;ACp8BhB;;ADu8BA;ECp8BE,kBAAY;EDw8BZ,aAAa;ECp8BX,mBAAyB;ED08BnB,8BAA8B;ECj9BxC,yBASQ;EAEF,sBAAkB;EAElB,mBAAkB;EAClB,iBAAa;ADy8BnB;;AAEA;EAGU,uBAAuB;AC59BjC;;AD+9BA;ECv8BgB,2BAAK;AD28BrB;;ACn+BA;EA+BI,uBAAmB;AD08BvB;;ACz+BA;EAiCM,eAAU;AD48BhB;;AAEA;EC18BM,iBAAa;EACb,kBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAc;EAQf,cAAA;ADq8BL;;AAEA;EC58BQ,kBAAe;EACf,gBAAW;EACX,0BAAQ;EACR,4BAAa;EACd,yBAAA;ED88BL,2BAA2B;AC18B7B;;AD68BA;EC18BE,yBAAY;EAEb,sBAAA;ED48BC,mBAAmB;EC18BnB,iBAAA;EACA,qBAAa;EACd,kBAAA;ED48BC,gBAAgB;EC38BlB,eAAK;EACL,iBAAK;EACH,WAAA;AD68BF;;AAEA;EC38BA,cAAa;AACb;;AD88BA;EACE,8BAA8B;AE1kChC;;AF6kCA;EACE,4BE3kCC;AF4kCH;;AE1kCA;EACE,2BAAc;AF6kChB;;AAEA;EACE,YAAY;EE5kCd,UAAQ;AF8kCR;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBE9kCa;EF+kCb,0BE9kCC;AF+kCH;;AE7kCA;EACE,sBAAc;AFglChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCE9kCa;AF+kCf;;AAEA;EACE,YE9kCC;EF+kCD,0BAA0B;EAC1B,2BAA2B;AE9kC7B;;AFilCA;EE9kCC,YAAA;EFglCC,2BAA2B;EGlnCzB,eAAuC;AHonC3C;;AAEA;EGjnCK,aAAA;EAEK,eAAiC;AHqnC3C;;AAEA;EGpnCI,cAAa;EACX,YAAsB;EACvB,2BAAA;EHsnCH,eAAe;EGhoCZ,aAAA;EHooCH,YAAY;EGnoCV,kBAAa;EACX,eAAsB;EACvB,kBAAA;EAGC,uBAAkD;EACnD,sBAAA;AHqoCL;;AAEA;EGpoCK,cAAA;EHsoCH,QAAQ;EGlpCN,WAAuC;EACrC,kBAAsC;EACvC,eAAA;AHopCL;;AAEA;EGnpCK,WAAA;AHqpCL;;AAEA;EGnpCK,2BAAA;EHqpCH,aAAa;EGppCX,YAAa;EACX,kBAAuB;AHspC7B;;AGjqCI;EHsqCF,aAAa;EGjqCV,yBAAA;EHqqCH,mBAAmB;AGnqCjB;;AHsqCJ;EACE,kBAAkB;EGpqChB,kBAAa;EAEZ,8DAAA;EHsqCH,aAAa;EGlrCX,gBAAuC;EACrC,gBAAsC;EACvC,eAAA;EHorCH,WAAW;AGnrCT;;AHsrCJ;EACE,kBAAkB;EGnrChB,eAAuC;EACrC,WAAgB;EACjB,QAAA;EHqrCH,aAAa;AGprCX;;AHurCJ;EGhsCM,aAAe;EAEJ,2BAAA;EACX,mBAAsB;AHqsC5B;;AGlsCI;EACE,kBAA0B;EAC3B,kBAAA;EACY,6CAAA;EACX,sBAAuB;EACxB,aAAA;EHssCH,gBAAgB;EGltCd,gBAAuC;EACrC,eAAwB;EACzB,cAAA;AHotCL;;AAEA;EGntCK,kBAAA;EHqtCH,eAAe;EGntCb,WAAuC;EACrC,QAAA;EACD,aAAA;AHqtCL;;AAEA;EGptCK,YAAA;EHstCH,aAAa;EGluCX,YAAuC;EACrC,kBAAsC;AHouC5C;;AGluCI;EACE,2BAAgC;AHquCtC;;AGluCI;;EAEC,wBAAA;EHquCH,SAAS;AGpuCP;;AHuuCJ,YGruCK;AHsuCL;EGlvCI,0BAAuC;AHovC3C;;AAEA;EGnvCI;IACE,YAAsB;EACvB;AHqvCL;;AAEA;EGnvCK;IHqvCD,WAAW;EGpvCX;AHsvCJ;;AAEA;EGlwCI;IACE,WAAe;EAChB;AHowCL;;AAEA;EGnwCK;IHqwCD,WAAW;EGnwCX;AHqwCJ;;AAEA;EGpwCI;IACE,WAAsB;IACvB,kBAAA;EHswCH;AGlxCE;;AHqxCJ;EACE;IGnxCE,WAAa;EACX;EACD;IHqxCD,eAAe;EGnxCf;AHqxCJ;;AAEA;EGpxCI,gBAAa;EACX,kBAAuB;AHsxC7B;;AGjyCI;EACE,0BAAsC;AHoyC5C;;AGlyCI;EACE,sBAAsB;AHqyC5B;;AGlyCI;EACE,2BAAwC;AHqyC9C;;AGnyCI;EACE,uBAAuB;AHsyC7B;;AGjzCI;EACE,6BAAgD;AHozCtD;;AGlzCI;EACE,sBAAsB;AHqzC5B;;AGlzCI;EACE,8BAAkD;AHqzCxD;;AGnzCI;EACE,uBAAuB;AHszC7B;;AGj0CI;EACE,2BAAsC;AHo0C5C;;AGl0CI;EACE,sBAAsB;AHq0C5B;;AGl0CI;EACE,4BAAwC;AHq0C9C;;AGn0CI;EACE,uBAAuB;AHs0C7B;;AGj1CI;EACE,4BAAgD;AHo1CtD;;AGl1CI;EACE,sBAAsB;AHq1C5B;;AGl1CI;EACE,6BAAkD;AHq1CxD;;AGn1CI;EACE,uBAAuB;AHs1C7B;;AGj2CI;EACE,0BAAsC;AHo2C5C;;AGl2CI;EACE,sBAAsB;AHq2C5B;;AGl2CI;EACE,2BAAwC;AHq2C9C;;AGn2CI;EACE,uBAAuB;AHs2C7B;;AGj3CI;EACE,6BAAgD;AHo3CtD;;AGl3CI;EACE,sBAAsB;AHq3C5B;;AGl3CI;EACE,8BAAkD;AHq3CxD;;AGn3CI;EACE,uBAAuB;AHs3C7B;;AGj4CI;EACE,2BAAsC;AHo4C5C;;AGl4CI;EACE,sBAAsB;AHq4C5B;;AGl4CI;EACE,4BAAwC;AHq4C9C;;AGn4CI;EACE,uBAAuB;AHs4C7B;;AGj5CI;EACE,4BAAgD;AHo5CtD;;AGl5CI;EACE,sBAAsB;AHq5C5B;;AGl5CI;EACE,6BAAkD;AHq5CxD;;AGn5CI;EACE,uBAAuB;AHs5C7B;;AGj6CI;EACE,2BAAsC;AHo6C5C;;AGl6CI;EACE,uBAAgC;AHq6CtC;;AGl6CI;EACE,4BAAwC;AHq6C9C;;AGn6CI;EACE,wBAAiC;AHs6CvC;;AGj7CI;EACE,8BAAgD;AHo7CtD;;AGl7CI;EACE,uBAAgC;AHq7CtC;;AGl7CI;EACE,+BAAkD;AHq7CxD;;AGn7CI;EACE,wBAAiC;AHs7CvC;;AGj8CI;EACE,4BAAsC;AHo8C5C;;AGl8CI;EACE,uBAAgC;AHq8CtC;;AGl8CI;EACE,6BAAwC;AHq8C9C;;AGn8CI;EACE,wBAAiC;AHs8CvC;;AGj9CI;EACE,6BAAgD;AHo9CtD;;AGl9CI;EACE,uBAAgC;AHq9CtC;;AGl9CI;EACE,8BAAkD;AHq9CxD;;AGn9CI;EACE,wBAAiC;AHs9CvC;;AGj+CI;EACE,2BAAsC;AHo+C5C;;AGl+CI;EACE,uBAAgC;AHq+CtC;;AGl+CI;EACE,4BAAwC;AHq+C9C;;AGn+CI;EACE,wBAAiC;AHs+CvC;;AGj/CI;EACE,8BAAgD;AHo/CtD;;AGl/CI;EACE,uBAAgC;AHq/CtC;;AGl/CI;EACE,+BAAkD;AHq/CxD;;AGn/CI;EACE,wBAAiC;AHs/CvC;;AGjgDI;EACE,4BAAsC;AHogD5C;;AGlgDI;EACE,uBAAgC;AHqgDtC;;AGlgDI;EACE,6BAAwC;AHqgD9C;;AGngDI;EACE,wBAAiC;AHsgDvC;;AGjhDI;EACE,6BAAgD;AHohDtD;;AGlhDI;EACE,uBAAgC;AHqhDtC;;AGlhDI;EACE,8BAAkD;AHqhDxD;;AGnhDI;EACE,wBAAiC;AHshDvC;;AGjiDI;EACE,2BAAsC;AHoiD5C;;AGliDI;EACE,uBAAgC;AHqiDtC;;AGliDI;EACE,4BAAwC;AHqiD9C;;AGniDI;EACE,wBAAiC;AHsiDvC;;AGjjDI;EACE,8BAAgD;AHojDtD;;AGljDI;EACE,uBAAgC;AHqjDtC;;AGljDI;EACE,+BAAkD;AHqjDxD;;AGnjDI;EACE,wBAAiC;AHsjDvC;;AGjkDI;EACE,4BAAsC;AHokD5C;;AGlkDI;EACE,uBAAgC;AHqkDtC;;AGlkDI;EACE,6BAAwC;AHqkD9C;;AGnkDI;EACE,wBAAiC;AHskDvC;;AGjlDI;EACE,6BAAgD;AHolDtD;;AGllDI;EACE,uBAAgC;AHqlDtC;;AGllDI;EACE,8BAAkD;AHqlDxD;;AGnlDI;EACE,wBAAiC;AHslDvC;;AGjmDI;EACE,2BAAsC;AHomD5C;;AGlmDI;EACE,uBAAgC;AHqmDtC;;AGlmDI;EACE,4BAAwC;AHqmD9C;;AGnmDI;EACE,wBAAiC;AHsmDvC;;AGjnDI;EACE,8BAAgD;AHonDtD;;AGlnDI;EACE,uBAAgC;AHqnDtC;;AGlnDI;EACE,+BAAkD;AHqnDxD;;AGnnDI;EACE,wBAAiC;AHsnDvC;;AGjoDI;EACE,4BAAsC;AHooD5C;;AGloDI;EACE,uBAAgC;AHqoDtC;;AGloDI;EACE,6BAAwC;AHqoD9C;;AGnoDI;EACE,wBAAiC;AHsoDvC;;AGjpDI;EACE,6BAAgD;AHopDtD;;AGlpDI;EACE,uBAAgC;AHqpDtC;;AGlpDI;EACE,8BAAkD;AHqpDxD;;AGnpDI;EACE,wBAAiC;AHspDvC;;AGjqDI;EACE,2BAAsC;AHoqD5C;;AGlqDI;EACE,uBAAgC;AHqqDtC;;AGlqDI;EACE,4BAAwC;AHqqD9C;;AGnqDI;EACE,wBAAiC;AHsqDvC;;AGjrDI;EACE,8BAAgD;AHorDtD;;AGlrDI;EACE,uBAAgC;AHqrDtC;;AGlrDI;EACE,+BAAkD;AHqrDxD;;AGnrDI;EACE,wBAAiC;AHsrDvC;;AGjsDI;EACE,4BAAsC;AHosD5C;;AGlsDI;EACE,uBAAgC;AHqsDtC;;AGlsDI;EACE,6BAAwC;AHqsD9C;;AGnsDI;EACE,wBAAiC;AHssDvC;;AGjtDI;EACE,6BAAgD;AHotDtD;;AGltDI;EACE,uBAAgC;AHqtDtC;;AGltDI;EACE,8BAAkD;AHqtDxD;;AGntDI;EACE,wBAAiC;AHstDvC;;AGjuDI;EACE,2BAAsC;AHouD5C;;AGluDI;EACE,uBAAgC;AHquDtC;;AGluDI;EACE,4BAAwC;AHquD9C;;AGnuDI;EACE,wBAAiC;AHsuDvC;;AGjvDI;EACE,8BAAgD;AHovDtD;;AGlvDI;EACE,uBAAgC;AHqvDtC;;AGlvDI;EACE,+BAAkD;AHqvDxD;;AGnvDI;EACE,wBAAiC;AHsvDvC;;AGjwDI;EACE,4BAAsC;AHowD5C;;AGlwDI;EACE,uBAAgC;AHqwDtC;;AGlwDI;EACE,6BAAwC;AHqwD9C;;AGnwDI;EACE,wBAAiC;AHswDvC;;AGjxDI;EACE,6BAAgD;AHoxDtD;;AGlxDI;EACE,uBAAgC;AHqxDtC;;AGlxDI;EACE,8BAAkD;AHqxDxD;;AGnxDI;EACE,wBAAiC;AHsxDvC;;AGjyDI;EACE,2BAAsC;AHoyD5C;;AGlyDI;EACE,uBAAgC;AHqyDtC;;AGlyDI;EACE,4BAAwC;AHqyD9C;;AGnyDI;EACE,wBAAiC;AHsyDvC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[":root {\n  font-size: 16px;\n}\n// button {\n//   &:hover {\n//     color: #16fff7 !important;\n//   }\n// }\n@font-face {\n  font-family: \"icomoon\";\n  src: url(\"fonts/icomoon.eot?rc22sm\");\n  src: url(\"fonts/icomoon.eot?rc22sm\") format(\"embedded-opentype\"),\n    url(\"fonts/icomoon.ttf?rc22sm\") format(\"truetype\"),\n    url(\"fonts/icomoon.woff?rc22sm\") format(\"woff\"),\n    url(\"fonts/icomoon.svg?rc22sm\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-\"],\n[class*=\" icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: \"icomoon\" !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-babyface:before {\n  content: \"\\e900\";\n}\n.icon-camera:before {\n  content: \"\\e901\";\n}\n.icon-book:before {\n  content: \"\\e902\";\n}\n.icon-18 .path1:before {\n  content: \"\\e903\";\n  color: rgb(137, 137, 137);\n}\n.icon-18 .path2:before {\n  content: \"\\e904\";\n  margin-left: -1em;\n  color: rgb(245, 248, 250);\n}\n.icon-18 .path3:before {\n  content: \"\\e905\";\n  margin-left: -1em;\n  color: rgb(137, 137, 137);\n}\n.icon-money .path1:before {\n  content: \"\\e906\";\n  color: rgb(137, 137, 137);\n}\n.icon-money .path2:before {\n  content: \"\\e907\";\n  margin-left: -0.884765625em;\n  color: rgb(255, 255, 255);\n}\n.icon-money .path3:before {\n  content: \"\\e908\";\n  margin-left: -0.884765625em;\n  color: rgb(255, 255, 255);\n}\n.icon-hand:before {\n  content: \"\\e909\";\n}\n.icon-music:before {\n  content: \"\\e90a\";\n}\n.icon-palette:before {\n  content: \"\\e90b\";\n}\n.icon-game:before {\n  content: \"\\e90c\";\n}\n.icon-spider:before {\n  content: \"\\e90d\";\n}\n.icon-web:before {\n  content: \"\\e90e\";\n}\n.icon-game {\n  font-size: 15px !important;\n}\n.MuiPopover-root {\n  z-index: 99999 !important;\n}\n.hide {\n  display: none !important;\n}\n.p-0 {\n  padding: 0 !important;\n}\n@mixin boxShadow {\n  box-shadow: 0 11px 24px rgba(0, 0, 0, 0.12);\n}\n.YourWrappingContainerClass {\n  position: relative;\n}\n@media (min-width: 768px) {\n  .YourWrappingContainerClass {\n    width: calc(((100% - 750px) / 2) + 780px) !important;\n    margin-right: 0;\n  }\n  .textright {\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n@mixin font16 {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n@mixin font14 {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px !important;\n  line-height: 21px !important;\n}\n@media (min-width: 992px) {\n  .YourWrappingContainerClass {\n    width: calc(((100% - 970px) / 2) + 1050px) !important;\n    margin-right: 0;\n  }\n}\n\n@media (min-width: 1200px) {\n  .YourWrappingContainerClass {\n    width: calc(((100% - 1170px) / 2) + 1250px) !important;\n    margin-right: 0;\n  }\n}\n@mixin textEllipsys {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre;\n}\n.filterIcon {\n  position: absolute !important;\n  svg {\n    font-size: 31px;\n    font-weight: 600;\n    color: #176386;\n    margin-right: 15px;\n  }\n  span {\n    font-size: 18px;\n    font-weight: 600;\n    color: #176386;\n  }\n}\n.posrel {\n  position: relative;\n}\n// a + a {\n//   margin-left: 8px !important;\n// }\n.clr-gry.slick-arrow {\n  top: 0;\n  position: absolute;\n}\n.slick-prev {\n  right: -11px;\n  top: 50%;\n  left: auto;\n  z-index: 99;\n  opacity: 0;\n}\n\n.slick-next {\n  right: -11px;\n  top: 50%;\n  left: auto;\n  z-index: 99;\n}\n.slick-list {\n  padding-left: 0px !important; // half partial\n}\n.p-o {\n  padding: 0 !important;\n}\nhr {\n  border-color: #3c3c3c;\n}\na {\n  text-decoration: none;\n}\n.Header {\n  height: 115px;\n  .logoImg {\n    height: 90px;\n  }\n}\n.InnerHeader {\n  height: 69px;\n  .logoImg {\n    height: 60px;\n  }\n}\n.mainHeading {\n  padding: 0 15px;\n}\nh4.accordianText {\n  font-size: 16px;\n  font-weight: 400;\n}\n.br-0 {\n  border-radius: 0 !important;\n}\n.textEllipsys {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre;\n}\n.d-flex {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  &.justifyEnd {\n    justify-content: flex-end;\n  }\n  &.flexStart {\n    justify-content: flex-start;\n  }\n}\n.width100 {\n  width: 100%;\n}\n.slick-dots {\n  text-align: end;\n}\n.slick-dots li {\n  margin: 0;\n  width: 15px;\n}\n.slick-dots li button:before {\n  color: #176386;\n  font-size: 10px;\n}\n\n.slick-dots li.slick-active button:before {\n  color: #3e37a2 !important;\n  font-size: 10px;\n}\n.favourites {\n  background-color: rgb(255, 255, 255);\n\n  border-radius: 5px;\n  position: relative;\n  padding: 38px 15px 15px;\n  .Ticker {\n    top: 52px;\n    right: 14px;\n  }\n  &:hover {\n    box-shadow: rgba(14, 14, 14, 0.25) 0px 0px 8px 0px;\n    transition: all 0.1s ease 0s;\n    transform: translateY(-2px);\n  }\n}\n\n$blue: 14bbf5;\n@mixin bgColor {\n  background: #14bbf5 !important;\n}\n@mixin bgcardColor {\n  background: #000 !important;\n  box-shadow: 0 3px 20px 0px rgba(0, 0, 0, 0.12%);\n}\n@mixin mainColor {\n  color: 14bbf5 !important;\n}\n.maincolor {\n  @include mainColor;\n}\n.bgcolor {\n  @include bgColor;\n}\n.bgblack {\n  background-color: #000 !important;\n}\n.bgCardcolor {\n  position: relative;\n  color: #f5f5f5;\n  border-radius: 0.25rem !important;\n  transition: all 0.4s ease-in-out 0s;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  &:hover {\n    transform: scale(1.021);\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);\n    transition: all 0.4s ease-in-out 0s;\n    border-radius: 15px !important;\n  }\n  .bgCardcolor_main {\n    width: 100%;\n  }\n}\n\n@mixin d-flex {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  &.justify-center {\n    justify-content: center;\n  }\n  &.justify-flex-start {\n    justify-content: flex-start;\n  }\n  &.align-flex-start {\n    align-items: flex-start;\n  }\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  background: #fff;\n  color: #52565c;\n  font-family: \"Poppins\", sans-serif;\n  overflow-x: hidden;\n}\n\n.Ticker {\n  position: absolute;\n  top: 20px;\n  padding: 8px 16px;\n  border-radius: 5px 0 0 5px;\n  right: 0px;\n  color: #fff;\n  display: block;\n  @include bgColor;\n  h5 {\n    font-size: 13px;\n    margin-bottom: 0 !important;\n    line-height: 18px;\n  }\n}\n\nlabel {\n  display: inline;\n  padding: 2em 0em 0.7em;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 27px;\n  color: #707070;\n  display: block;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25em;\n}\n\n\n\n// button + button {\n//   margin: 0 10px !important;\n// }\n.label-warning {\n  background-color: #f0ad4e;\n}\n.label-warning[href]:focus,\n.label-warning[href]:hover {\n  background-color: #ec971f;\n}\n.label-danger {\n  background-color: #d9534f;\n}\n.label-danger[href]:focus,\n.label-danger[href]:hover {\n  background-color: #21c21b;\n}\n.label-success {\n  background-color: #21c21b;\n}\n.label-success[href]:focus,\n.label-success[href]:hover {\n  background-color: #21c21b;\n}\n\nfigure {\n  margin: 0;\n}\n.usersView {\n  margin-bottom: 15px;\n  position: relative;\n  .figure {\n    margin-top: 60px;\n    @include d-flex;\n    position: relative;\n    // overflow: hidden;\n    &.profilePicture {\n      img {\n        min-width: 800px;\n        width: 100%;\n      }\n    }\n    img {\n      width: 100%;\n    }\n  }\n  .usersPic {\n    position: relative;\n    margin-top: -80px;\n    left: 50%;\n    transform: translateX(-50%);\n    figure {\n      border-radius: 50%;\n      border: 2px solid #f1f1f1;\n      width: 150px;\n      height: 150px;\n      position: relative;\n      @include d-flex;\n      // overflow: hidden;\n      margin: 0px auto 13px;\n      img.check_icon {\n        position: absolute;\n        width: auto !important;\n        height: auto !important;\n        right: 20px;\n        top: 4px;\n      }\n      img {\n        width: 100%;\n      }\n    }\n  }\n}\n.userDetails {\n  text-align: center;\n  background: #fff;\n  border-radius: 7px;\n  h4 {\n    color: #000;\n    margin-bottom: 20px !important;\n  }\n  h6 {\n    color: #0d8ccd;\n    @include font16;\n    font-weight: 600;\n  }\n  .tokenAddress {\n    border: 1px solid #e9e9e9;\n    box-sizing: border-box;\n    border-radius: 15px;\n    padding: 2px 10px;\n    font-size: 15px;\n    line-height: 22px;\n    color: #898989;\n    margin-left: 10px;\n  }\n}\n.userPic {\n  margin-top: -60px;\n  z-index: 99;\n  position: relative;\n  background: #fff;\n  border-radius: 7px;\n  @include boxShadow;\n  padding: 11px;\n  figure {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n    border-radius: 7px;\n    height: 180px;\n    width: 100%;\n    position: relative;\n    img {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      max-width: 100%;\n      width: 100%;\n      transform: translate(-50%, -50%);\n      @include boxShadow;\n      border-radius: 7px;\n    }\n  }\n}\n.socialLink {\n  @include d-flex;\n  justify-content: center;\n  a {\n    @include font16;\n    color: #000;\n    font-weight: 600;\n    @include d-flex;\n    justify-content: center;\n  }\n  svg {\n    font-size: 22px;\n    margin-right: 10px;\n    margin-left: 15px;\n  }\n}\n.listingFooter {\n  li {\n    padding: 5px 0;\n    a {\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 24px;\n      cursor: pointer;\n      &:hover {\n        text-decoration: none;\n      }\n    }\n  }\n}\n.media_links {\n  padding: 0;\n  margin: 0;\n  li {\n    padding: 0;\n    margin-bottom: 20px;\n    a {\n      margin-right: 20px;\n      svg {\n        font-size: 22px;\n      }\n    }\n  }\n}\n.uploadBox {\n  background: #ffffff;\n  border: 1px dashed #898989;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);\n  border-radius: 25px;\n  @include d-flex;\n  height: 132px;\n  flex-direction: column;\n  padding: 45px 25px;\n  h6 {\n    @include font16;\n  }\n  p {\n    @include font14;\n  }\n}\n.setPrice {\n  background: #ffffff;\n  border: 1px solid #898989;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);\n  border-radius: 25px;\n  height: 150px;\n  width: 150px;\n  @include d-flex;\n  flex-direction: column;\n  justify-content: center;\n  @include font16;\n  color: #000000;\n  cursor: pointer;\n  svg {\n    font-size: 35px;\n    margin-bottom: 8px;\n  }\n  img {\n    width: 35px;\n    margin-bottom: 8px;\n  }\n  &.active {\n    border: 1px solid #039be3;\n    color: #039be3;\n  }\n  p {\n    @include font14;\n    color: #898989;\n  }\n}\nsmall {\n  @include font14;\n  margin-top: 10px;\n  color: #898989;\n  font-weight: 400;\n  display: block;\n  span {\n    color: #0f8aca;\n  }\n}\nimg {\n  image-rendering: -webkit-optimize-contrast;\n}\n.preiewBox {\n  background: #ffffff;\n  border: 1px solid #898989;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);\n  border-radius: 25px;\n  height: 470px;\n  @include d-flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.extraHeader {\n  max-width: 600px;\n  margin: 0 auto;\n  h4 {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 26px;\n    line-height: 39px;\n    color: #000;\n  }\n  p {\n    @include font16;\n    color: #898989;\n    margin-bottom: 25px;\n    span {\n      color: #0d8ccd;\n      display: block;\n    }\n  }\n}\n.connectWallet {\n  @include d-flex;\n  background: #ffffff;\n  border: 1px solid #e9e9e9;\n  box-sizing: border-box;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);\n  border-radius: 25px;\n  padding: 10px 25px;\n  min-height: 140px;\n  h4 {\n    margin-bottom: 0;\n    font-size: 22px;\n    line-height: 36px;\n    font-weight: 500;\n    color: #898989;\n  }\n}\n.lowerHeader {\n  h3 {\n    font-weight: 600;\n    font-size: 32px;\n    line-height: 48px;\n    text-align: center;\n    color: #000000;\n  }\n  p {\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 27px;\n    text-align: center;\n    margin-top: 20px;\n    color: #898989;\n  }\n}\n.faqHeader {\n  font-weight: 600;\n  font-size: 26px;\n  line-height: 39px;\n\n  color: #0d8ccd;\n}\np.MuiFormHelperText-root.MuiFormHelperText-contained.Mui-error {\n  margin-left: 0px;\n}\n\n@media (max-width: 767px) {\n  .connectWallet {\n    display: block;\n    text-align: center;\n    h4 {\n      font-size: 17px;\n      line-height: 26px;\n      margin-bottom: 15px;\n    }\n  }\n}\n.nftData {\n  margin-top: 10px !important;\n  display: block;\n  @include font14;\n  color: #898989;\n  span {\n    color: #000;\n  }\n  span.blue {\n    color: #039be3;\n  }\n}\n.roundBox {\n  margin-right: 15px;\n  @include d-flex;\n  border: 2px solid #bdbcbc;\n  box-sizing: border-box;\n  border-radius: 50px;\n  padding: 4px 12px;\n  svg {\n    font-size: 18px;\n  }\n  h5 {\n    margin-left: 10px;\n    @include font16;\n    color: #3d3d3d;\n  }\n}\n.smallfont {\n  @include font14;\n  color: #898989 !important;\n  font-weight: 300 !important;\n}\n.creatorButton {\n  border: 2px solid #039be3;\n  box-sizing: border-box;\n  border-radius: 50px;\n  padding: 7px 29px;\n\n  display: inline-block;\n  @include font16;\n  color: #000;\n  span {\n    color: #039be3;\n  }\n}\n\n.mb-10 {\n  margin-bottom: 10px !important;\n}\n.ml-10 {\n  margin-left: 10px !important;\n}\n.p.MuiFormHelperText-root.MuiFormHelperText-contained.Mui-error {\n  margin-left: 0px !important;\n}\n.MuiInputBase-inputMultiline {\n  height: 22px;\n  padding: 0;\n}\n\n.jodit-react-container{\n  width:100%\n}",":root {\n  font-size: 16px;\n}\n\n@font-face {\n  font-family: \"icomoon\";\n  src: url(\"fonts/icomoon.eot?rc22sm\");\n  src: url(\"fonts/icomoon.eot?rc22sm\") format(\"embedded-opentype\"), url(\"fonts/icomoon.ttf?rc22sm\") format(\"truetype\"), url(\"fonts/icomoon.woff?rc22sm\") format(\"woff\"), url(\"fonts/icomoon.svg?rc22sm\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-\"],\n[class*=\" icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: \"icomoon\" !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-babyface:before {\n  content: \"\\e900\";\n}\n\n.icon-camera:before {\n  content: \"\\e901\";\n}\n\n.icon-book:before {\n  content: \"\\e902\";\n}\n\n.icon-18 .path1:before {\n  content: \"\\e903\";\n  color: #898989;\n}\n\n.icon-18 .path2:before {\n  content: \"\\e904\";\n  margin-left: -1em;\n  color: #f5f8fa;\n}\n\n.icon-18 .path3:before {\n  content: \"\\e905\";\n  margin-left: -1em;\n  color: #898989;\n}\n\n.icon-money .path1:before {\n  content: \"\\e906\";\n  color: #898989;\n}\n\n.icon-money .path2:before {\n  content: \"\\e907\";\n  margin-left: -0.884765625em;\n  color: white;\n}\n\n.icon-money .path3:before {\n  content: \"\\e908\";\n  margin-left: -0.884765625em;\n  color: white;\n}\n\n.icon-hand:before {\n  content: \"\\e909\";\n}\n\n.icon-music:before {\n  content: \"\\e90a\";\n}\n\n.icon-palette:before {\n  content: \"\\e90b\";\n}\n\n.icon-game:before {\n  content: \"\\e90c\";\n}\n\n.icon-spider:before {\n  content: \"\\e90d\";\n}\n\n.icon-web:before {\n  content: \"\\e90e\";\n}\n\n.icon-game {\n  font-size: 15px !important;\n}\n\n.MuiPopover-root {\n  z-index: 99999 !important;\n}\n\n.hide {\n  display: none !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.YourWrappingContainerClass {\n  position: relative;\n}\n\n@media (min-width: 768px) {\n  .YourWrappingContainerClass {\n    width: calc(((100% - 750px) / 2) + 780px) !important;\n    margin-right: 0;\n  }\n  .textright {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n  }\n}\n\n@media (min-width: 992px) {\n  .YourWrappingContainerClass {\n    width: calc(((100% - 970px) / 2) + 1050px) !important;\n    margin-right: 0;\n  }\n}\n\n@media (min-width: 1200px) {\n  .YourWrappingContainerClass {\n    width: calc(((100% - 1170px) / 2) + 1250px) !important;\n    margin-right: 0;\n  }\n}\n\n.filterIcon {\n  position: absolute !important;\n}\n\n.filterIcon svg {\n  font-size: 31px;\n  font-weight: 600;\n  color: #176386;\n  margin-right: 15px;\n}\n\n.filterIcon span {\n  font-size: 18px;\n  font-weight: 600;\n  color: #176386;\n}\n\n.posrel {\n  position: relative;\n}\n\n.clr-gry.slick-arrow {\n  top: 0;\n  position: absolute;\n}\n\n.slick-prev {\n  right: -11px;\n  top: 50%;\n  left: auto;\n  z-index: 99;\n  opacity: 0;\n}\n\n.slick-next {\n  right: -11px;\n  top: 50%;\n  left: auto;\n  z-index: 99;\n}\n\n.slick-list {\n  padding-left: 0px !important;\n}\n\n.p-o {\n  padding: 0 !important;\n}\n\nhr {\n  border-color: #3c3c3c;\n}\n\na {\n  text-decoration: none;\n}\n\n.Header {\n  height: 115px;\n}\n\n.Header .logoImg {\n  height: 90px;\n}\n\n.InnerHeader {\n  height: 69px;\n}\n\n.InnerHeader .logoImg {\n  height: 60px;\n}\n\n.mainHeading {\n  padding: 0 15px;\n}\n\nh4.accordianText {\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.br-0 {\n  border-radius: 0 !important;\n}\n\n.textEllipsys {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre;\n}\n\n.d-flex {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.d-flex.justifyEnd {\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n\n.d-flex.flexStart {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n\n.width100 {\n  width: 100%;\n}\n\n.slick-dots {\n  text-align: end;\n}\n\n.slick-dots li {\n  margin: 0;\n  width: 15px;\n}\n\n.slick-dots li button:before {\n  color: #176386;\n  font-size: 10px;\n}\n\n.slick-dots li.slick-active button:before {\n  color: #3e37a2 !important;\n  font-size: 10px;\n}\n\n.favourites {\n  background-color: white;\n  border-radius: 5px;\n  position: relative;\n  padding: 38px 15px 15px;\n}\n\n.favourites .Ticker {\n  top: 52px;\n  right: 14px;\n}\n\n.favourites:hover {\n  -webkit-box-shadow: rgba(14, 14, 14, 0.25) 0px 0px 8px 0px;\n          box-shadow: rgba(14, 14, 14, 0.25) 0px 0px 8px 0px;\n  -webkit-transition: all 0.1s ease 0s;\n  transition: all 0.1s ease 0s;\n  -webkit-transform: translateY(-2px);\n          transform: translateY(-2px);\n}\n\n.maincolor {\n  color: 14bbf5 !important;\n}\n\n.bgcolor {\n  background: #14bbf5 !important;\n}\n\n.bgblack {\n  background-color: #000 !important;\n}\n\n.bgCardcolor {\n  position: relative;\n  color: #f5f5f5;\n  border-radius: 0.25rem !important;\n  -webkit-transition: all 0.4s ease-in-out 0s;\n  transition: all 0.4s ease-in-out 0s;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n.bgCardcolor:hover {\n  -webkit-transform: scale(1.021);\n          transform: scale(1.021);\n  -webkit-box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);\n          box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);\n  -webkit-transition: all 0.4s ease-in-out 0s;\n  transition: all 0.4s ease-in-out 0s;\n  border-radius: 15px !important;\n}\n\n.bgCardcolor .bgCardcolor_main {\n  width: 100%;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  background: #fff;\n  color: #52565c;\n  font-family: \"Poppins\", sans-serif;\n  overflow-x: hidden;\n}\n\n.Ticker {\n  position: absolute;\n  top: 20px;\n  padding: 8px 16px;\n  border-radius: 5px 0 0 5px;\n  right: 0px;\n  color: #fff;\n  display: block;\n  background: #14bbf5 !important;\n}\n\n.Ticker h5 {\n  font-size: 13px;\n  margin-bottom: 0 !important;\n  line-height: 18px;\n}\n\nlabel {\n  display: inline;\n  padding: 2em 0em 0.7em;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 27px;\n  color: #707070;\n  display: block;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25em;\n}\n\n.label-warning {\n  background-color: #f0ad4e;\n}\n\n.label-warning[href]:focus,\n.label-warning[href]:hover {\n  background-color: #ec971f;\n}\n\n.label-danger {\n  background-color: #d9534f;\n}\n\n.label-danger[href]:focus,\n.label-danger[href]:hover {\n  background-color: #21c21b;\n}\n\n.label-success {\n  background-color: #21c21b;\n}\n\n.label-success[href]:focus,\n.label-success[href]:hover {\n  background-color: #21c21b;\n}\n\nfigure {\n  margin: 0;\n}\n\n.usersView {\n  margin-bottom: 15px;\n  position: relative;\n}\n\n.usersView .figure {\n  margin-top: 60px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  position: relative;\n}\n\n.usersView .figure.justify-center {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.usersView .figure.justify-flex-start {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n\n.usersView .figure.align-flex-start {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n\n.usersView .figure.profilePicture img {\n  min-width: 800px;\n  width: 100%;\n}\n\n.usersView .figure img {\n  width: 100%;\n}\n\n.usersView .usersPic {\n  position: relative;\n  margin-top: -80px;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n}\n\n.usersView .usersPic figure {\n  border-radius: 50%;\n  border: 2px solid #f1f1f1;\n  width: 150px;\n  height: 150px;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin: 0px auto 13px;\n}\n\n.usersView .usersPic figure.justify-center {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.usersView .usersPic figure.justify-flex-start {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n\n.usersView .usersPic figure.align-flex-start {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n\n.usersView .usersPic figure img.check_icon {\n  position: absolute;\n  width: auto !important;\n  height: auto !important;\n  right: 20px;\n  top: 4px;\n}\n\n.usersView .usersPic figure img {\n  width: 100%;\n}\n\n.userDetails {\n  text-align: center;\n  background: #fff;\n  border-radius: 7px;\n}\n\n.userDetails h4 {\n  color: #000;\n  margin-bottom: 20px !important;\n}\n\n.userDetails h6 {\n  color: #0d8ccd;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 600;\n}\n\n.userDetails .tokenAddress {\n  border: 1px solid #e9e9e9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 15px;\n  padding: 2px 10px;\n  font-size: 15px;\n  line-height: 22px;\n  color: #898989;\n  margin-left: 10px;\n}\n\n.userPic {\n  margin-top: -60px;\n  z-index: 99;\n  position: relative;\n  background: #fff;\n  border-radius: 7px;\n  -webkit-box-shadow: 0 11px 24px rgba(0, 0, 0, 0.12);\n          box-shadow: 0 11px 24px rgba(0, 0, 0, 0.12);\n  padding: 11px;\n}\n\n.userPic figure {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  overflow: hidden;\n  border-radius: 7px;\n  height: 180px;\n  width: 100%;\n  position: relative;\n}\n\n.userPic figure img {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  max-width: 100%;\n  width: 100%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-box-shadow: 0 11px 24px rgba(0, 0, 0, 0.12);\n          box-shadow: 0 11px 24px rgba(0, 0, 0, 0.12);\n  border-radius: 7px;\n}\n\n.socialLink {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.socialLink.justify-center {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.socialLink.justify-flex-start {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n\n.socialLink.align-flex-start {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n\n.socialLink a {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: #000;\n  font-weight: 600;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.socialLink a.justify-center {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.socialLink a.justify-flex-start {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n\n.socialLink a.align-flex-start {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n\n.socialLink svg {\n  font-size: 22px;\n  margin-right: 10px;\n  margin-left: 15px;\n}\n\n.listingFooter li {\n  padding: 5px 0;\n}\n\n.listingFooter li a {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n  cursor: pointer;\n}\n\n.listingFooter li a:hover {\n  text-decoration: none;\n}\n\n.media_links {\n  padding: 0;\n  margin: 0;\n}\n\n.media_links li {\n  padding: 0;\n  margin-bottom: 20px;\n}\n\n.media_links li a {\n  margin-right: 20px;\n}\n\n.media_links li a svg {\n  font-size: 22px;\n}\n\n.uploadBox {\n  background: #ffffff;\n  border: 1px dashed #898989;\n  -webkit-box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);\n          box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);\n  border-radius: 25px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  height: 132px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  padding: 45px 25px;\n}\n\n.uploadBox.justify-center {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.uploadBox.justify-flex-start {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n\n.uploadBox.align-flex-start {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n\n.uploadBox h6 {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.uploadBox p {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px !important;\n  line-height: 21px !important;\n}\n\n.setPrice {\n  background: #ffffff;\n  border: 1px solid #898989;\n  -webkit-box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);\n          box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);\n  border-radius: 25px;\n  height: 150px;\n  width: 150px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: #000000;\n  cursor: pointer;\n}\n\n.setPrice.justify-center {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.setPrice.justify-flex-start {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n\n.setPrice.align-flex-start {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n\n.setPrice svg {\n  font-size: 35px;\n  margin-bottom: 8px;\n}\n\n.setPrice img {\n  width: 35px;\n  margin-bottom: 8px;\n}\n\n.setPrice.active {\n  border: 1px solid #039be3;\n  color: #039be3;\n}\n\n.setPrice p {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px !important;\n  line-height: 21px !important;\n  color: #898989;\n}\n\nsmall {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px !important;\n  line-height: 21px !important;\n  margin-top: 10px;\n  color: #898989;\n  font-weight: 400;\n  display: block;\n}\n\nsmall span {\n  color: #0f8aca;\n}\n\nimg {\n  image-rendering: -webkit-optimize-contrast;\n}\n\n.preiewBox {\n  background: #ffffff;\n  border: 1px solid #898989;\n  -webkit-box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);\n          box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);\n  border-radius: 25px;\n  height: 470px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.preiewBox.justify-center {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.preiewBox.justify-flex-start {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n\n.preiewBox.align-flex-start {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n\n.extraHeader {\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.extraHeader h4 {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 26px;\n  line-height: 39px;\n  color: #000;\n}\n\n.extraHeader p {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: #898989;\n  margin-bottom: 25px;\n}\n\n.extraHeader p span {\n  color: #0d8ccd;\n  display: block;\n}\n\n.connectWallet {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  background: #ffffff;\n  border: 1px solid #e9e9e9;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  -webkit-box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);\n          box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);\n  border-radius: 25px;\n  padding: 10px 25px;\n  min-height: 140px;\n}\n\n.connectWallet.justify-center {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.connectWallet.justify-flex-start {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n\n.connectWallet.align-flex-start {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n\n.connectWallet h4 {\n  margin-bottom: 0;\n  font-size: 22px;\n  line-height: 36px;\n  font-weight: 500;\n  color: #898989;\n}\n\n.lowerHeader h3 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 48px;\n  text-align: center;\n  color: #000000;\n}\n\n.lowerHeader p {\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 27px;\n  text-align: center;\n  margin-top: 20px;\n  color: #898989;\n}\n\n.faqHeader {\n  font-weight: 600;\n  font-size: 26px;\n  line-height: 39px;\n  color: #0d8ccd;\n}\n\np.MuiFormHelperText-root.MuiFormHelperText-contained.Mui-error {\n  margin-left: 0px;\n}\n\n@media (max-width: 767px) {\n  .connectWallet {\n    display: block;\n    text-align: center;\n  }\n  .connectWallet h4 {\n    font-size: 17px;\n    line-height: 26px;\n    margin-bottom: 15px;\n  }\n}\n\n.nftData {\n  margin-top: 10px !important;\n  display: block;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px !important;\n  line-height: 21px !important;\n  color: #898989;\n}\n\n.nftData span {\n  color: #000;\n}\n\n.nftData span.blue {\n  color: #039be3;\n}\n\n.roundBox {\n  margin-right: 15px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  border: 2px solid #bdbcbc;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 50px;\n  padding: 4px 12px;\n}\n\n.roundBox.justify-center {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.roundBox.justify-flex-start {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n\n.roundBox.align-flex-start {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n\n.roundBox svg {\n  font-size: 18px;\n}\n\n.roundBox h5 {\n  margin-left: 10px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: #3d3d3d;\n}\n\n.smallfont {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px !important;\n  line-height: 21px !important;\n  color: #898989 !important;\n  font-weight: 300 !important;\n}\n\n.creatorButton {\n  border: 2px solid #039be3;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 50px;\n  padding: 7px 29px;\n  display: inline-block;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: #000;\n}\n\n.creatorButton span {\n  color: #039be3;\n}\n\n.mb-10 {\n  margin-bottom: 10px !important;\n}\n\n.ml-10 {\n  margin-left: 10px !important;\n}\n\n.p.MuiFormHelperText-root.MuiFormHelperText-contained.Mui-error {\n  margin-left: 0px !important;\n}\n\n.MuiInputBase-inputMultiline {\n  height: 22px;\n  padding: 0;\n}\n\n.jodit-react-container {\n  width: 100%;\n}\n\n.btnWidth {\n  width: 300px !important;\n  max-width: 100% !important;\n}\n\n.btn-block {\n  width: 100% !important;\n}\n\n.Logocenter {\n  text-align: center;\n}\n\n.topmenu {\n  border-bottom: solid 2px #8d00f2;\n}\n\n.btnHight {\n  height: 35px;\n  font-size: 12px !important;\n  margin-top: 16px !important;\n}\n\n.removeredius {\n  width: 150px;\n  border-radius: 0 !important;\n  max-width: 100%;\n}\n\n.tokenList {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n\n.tokenList li {\n  color: #141518;\n  width: 103px;\n  border: solid 0.5px #e5e3dd;\n  margin: 0px 5px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 5px;\n  position: relative;\n  font-size: 10px;\n  text-align: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  background-color: #fff;\n}\n\n.tokenList li svg {\n  color: #60be60;\n  right: 0;\n  bottom: 0px;\n  position: absolute;\n  font-size: 20px;\n}\n\n.tokenList li img {\n  width: 30px;\n}\n\n.chat-Box {\n  border: solid 0.5px #e5e3dd;\n  padding: 15px;\n  height: 65vh;\n  overflow-y: scroll;\n}\n\n.chat-Box .right-Box {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-bottom: 25px;\n}\n\n.chat-Box .right-Box div {\n  position: relative;\n  border-radius: 9px;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(#c04848), to(#480048));\n  background-image: linear-gradient(to bottom, #c04848, #480048);\n  padding: 15px;\n  max-width: 500px;\n  min-width: 100px;\n  font-size: 15px;\n  color: #fff;\n}\n\n.chat-Box .right-Box div span {\n  position: absolute;\n  font-size: 11px;\n  color: #000;\n  right: 0;\n  bottom: -25px;\n}\n\n.chat-Box .left-Box {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  margin-bottom: 25px;\n}\n\n.chat-Box .left-Box div {\n  position: relative;\n  border-radius: 9px;\n  -webkit-box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);\n          box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);\n  background-color: #fff;\n  padding: 15px;\n  max-width: 500px;\n  min-width: 100px;\n  font-size: 15px;\n  color: #707070;\n}\n\n.chat-Box .left-Box div span {\n  position: absolute;\n  font-size: 11px;\n  color: #000;\n  right: 0;\n  bottom: -25px;\n}\n\n.userimg {\n  width: 100px;\n  height: 100px;\n  margin: auto;\n  border-radius: 50%;\n}\n\n.p.MuiFormHelperText-root.MuiFormHelperText-contained.Mui-error {\n  margin-left: 0px !important;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n@media (max-width: 1640px) {\n  .tokenList li {\n    width: 101px;\n  }\n}\n\n@media (max-width: 1440px) {\n  .tokenList li {\n    width: 85px;\n  }\n}\n\n@media (max-width: 1366px) {\n  .tokenList li {\n    width: 80px;\n  }\n}\n\n@media (max-width: 1280px) {\n  .tokenList li {\n    width: 75px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .tokenList li {\n    width: 75px;\n    margin-bottom: 5px;\n  }\n}\n\n@media (max-width: 767px) {\n  .tokenList li {\n    width: 67px;\n  }\n  .imgWidth {\n    max-width: 100%;\n  }\n}\n\n.MuiFormHelperText-contained {\n  margin-left: 0px;\n  margin-right: 14px;\n}\n\n.m-t-0 {\n  margin-top: 0px !important;\n}\n\n.m-0 {\n  margin: 0px !important;\n}\n\n.p-t-0 {\n  padding-top: 0px !important;\n}\n\n.p-0 {\n  padding: 0px !important;\n}\n\n.m-b-0 {\n  margin-bottom: 0px !important;\n}\n\n.m-0 {\n  margin: 0px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0px !important;\n}\n\n.p-0 {\n  padding: 0px !important;\n}\n\n.m-l-0 {\n  margin-left: 0px !important;\n}\n\n.m-0 {\n  margin: 0px !important;\n}\n\n.p-l-0 {\n  padding-left: 0px !important;\n}\n\n.p-0 {\n  padding: 0px !important;\n}\n\n.m-r-0 {\n  margin-right: 0px !important;\n}\n\n.m-0 {\n  margin: 0px !important;\n}\n\n.p-r-0 {\n  padding-right: 0px !important;\n}\n\n.p-0 {\n  padding: 0px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-5 {\n  margin: 5px !important;\n}\n\n.p-t-5 {\n  padding-top: 5px !important;\n}\n\n.p-5 {\n  padding: 5px !important;\n}\n\n.m-b-5 {\n  margin-bottom: 5px !important;\n}\n\n.m-5 {\n  margin: 5px !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-5 {\n  padding: 5px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-5 {\n  margin: 5px !important;\n}\n\n.p-l-5 {\n  padding-left: 5px !important;\n}\n\n.p-5 {\n  padding: 5px !important;\n}\n\n.m-r-5 {\n  margin-right: 5px !important;\n}\n\n.m-5 {\n  margin: 5px !important;\n}\n\n.p-r-5 {\n  padding-right: 5px !important;\n}\n\n.p-5 {\n  padding: 5px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-10 {\n  margin: 10px !important;\n}\n\n.p-t-10 {\n  padding-top: 10px !important;\n}\n\n.p-10 {\n  padding: 10px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-10 {\n  margin: 10px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-10 {\n  padding: 10px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-10 {\n  margin: 10px !important;\n}\n\n.p-l-10 {\n  padding-left: 10px !important;\n}\n\n.p-10 {\n  padding: 10px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-10 {\n  margin: 10px !important;\n}\n\n.p-r-10 {\n  padding-right: 10px !important;\n}\n\n.p-10 {\n  padding: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-15 {\n  margin: 15px !important;\n}\n\n.p-t-15 {\n  padding-top: 15px !important;\n}\n\n.p-15 {\n  padding: 15px !important;\n}\n\n.m-b-15 {\n  margin-bottom: 15px !important;\n}\n\n.m-15 {\n  margin: 15px !important;\n}\n\n.p-b-15 {\n  padding-bottom: 15px !important;\n}\n\n.p-15 {\n  padding: 15px !important;\n}\n\n.m-l-15 {\n  margin-left: 15px !important;\n}\n\n.m-15 {\n  margin: 15px !important;\n}\n\n.p-l-15 {\n  padding-left: 15px !important;\n}\n\n.p-15 {\n  padding: 15px !important;\n}\n\n.m-r-15 {\n  margin-right: 15px !important;\n}\n\n.m-15 {\n  margin: 15px !important;\n}\n\n.p-r-15 {\n  padding-right: 15px !important;\n}\n\n.p-15 {\n  padding: 15px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-20 {\n  margin: 20px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-20 {\n  padding: 20px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-20 {\n  margin: 20px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-20 {\n  padding: 20px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-20 {\n  margin: 20px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-20 {\n  padding: 20px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-20 {\n  margin: 20px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-20 {\n  padding: 20px !important;\n}\n\n.m-t-25 {\n  margin-top: 25px !important;\n}\n\n.m-25 {\n  margin: 25px !important;\n}\n\n.p-t-25 {\n  padding-top: 25px !important;\n}\n\n.p-25 {\n  padding: 25px !important;\n}\n\n.m-b-25 {\n  margin-bottom: 25px !important;\n}\n\n.m-25 {\n  margin: 25px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-25 {\n  padding: 25px !important;\n}\n\n.m-l-25 {\n  margin-left: 25px !important;\n}\n\n.m-25 {\n  margin: 25px !important;\n}\n\n.p-l-25 {\n  padding-left: 25px !important;\n}\n\n.p-25 {\n  padding: 25px !important;\n}\n\n.m-r-25 {\n  margin-right: 25px !important;\n}\n\n.m-25 {\n  margin: 25px !important;\n}\n\n.p-r-25 {\n  padding-right: 25px !important;\n}\n\n.p-25 {\n  padding: 25px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-30 {\n  margin: 30px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-30 {\n  margin: 30px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-30 {\n  margin: 30px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-30 {\n  margin: 30px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.m-t-35 {\n  margin-top: 35px !important;\n}\n\n.m-35 {\n  margin: 35px !important;\n}\n\n.p-t-35 {\n  padding-top: 35px !important;\n}\n\n.p-35 {\n  padding: 35px !important;\n}\n\n.m-b-35 {\n  margin-bottom: 35px !important;\n}\n\n.m-35 {\n  margin: 35px !important;\n}\n\n.p-b-35 {\n  padding-bottom: 35px !important;\n}\n\n.p-35 {\n  padding: 35px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-35 {\n  margin: 35px !important;\n}\n\n.p-l-35 {\n  padding-left: 35px !important;\n}\n\n.p-35 {\n  padding: 35px !important;\n}\n\n.m-r-35 {\n  margin-right: 35px !important;\n}\n\n.m-35 {\n  margin: 35px !important;\n}\n\n.p-r-35 {\n  padding-right: 35px !important;\n}\n\n.p-35 {\n  padding: 35px !important;\n}\n\n.m-t-40 {\n  margin-top: 40px !important;\n}\n\n.m-40 {\n  margin: 40px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-40 {\n  padding: 40px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-40 {\n  margin: 40px !important;\n}\n\n.p-b-40 {\n  padding-bottom: 40px !important;\n}\n\n.p-40 {\n  padding: 40px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-40 {\n  margin: 40px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-40 {\n  padding: 40px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n.m-40 {\n  margin: 40px !important;\n}\n\n.p-r-40 {\n  padding-right: 40px !important;\n}\n\n.p-40 {\n  padding: 40px !important;\n}\n\n.m-t-45 {\n  margin-top: 45px !important;\n}\n\n.m-45 {\n  margin: 45px !important;\n}\n\n.p-t-45 {\n  padding-top: 45px !important;\n}\n\n.p-45 {\n  padding: 45px !important;\n}\n\n.m-b-45 {\n  margin-bottom: 45px !important;\n}\n\n.m-45 {\n  margin: 45px !important;\n}\n\n.p-b-45 {\n  padding-bottom: 45px !important;\n}\n\n.p-45 {\n  padding: 45px !important;\n}\n\n.m-l-45 {\n  margin-left: 45px !important;\n}\n\n.m-45 {\n  margin: 45px !important;\n}\n\n.p-l-45 {\n  padding-left: 45px !important;\n}\n\n.p-45 {\n  padding: 45px !important;\n}\n\n.m-r-45 {\n  margin-right: 45px !important;\n}\n\n.m-45 {\n  margin: 45px !important;\n}\n\n.p-r-45 {\n  padding-right: 45px !important;\n}\n\n.p-45 {\n  padding: 45px !important;\n}\n\n.m-t-50 {\n  margin-top: 50px !important;\n}\n\n.m-50 {\n  margin: 50px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-50 {\n  padding: 50px !important;\n}\n\n.m-b-50 {\n  margin-bottom: 50px !important;\n}\n\n.m-50 {\n  margin: 50px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-50 {\n  padding: 50px !important;\n}\n\n.m-l-50 {\n  margin-left: 50px !important;\n}\n\n.m-50 {\n  margin: 50px !important;\n}\n\n.p-l-50 {\n  padding-left: 50px !important;\n}\n\n.p-50 {\n  padding: 50px !important;\n}\n\n.m-r-50 {\n  margin-right: 50px !important;\n}\n\n.m-50 {\n  margin: 50px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-50 {\n  padding: 50px !important;\n}\n",".btnWidth {\n  width: 300px !important;\n  max-width: 100% !important;\n}\n.btn-block {\n  width: 100% !important;\n}\n.Logocenter {\n  text-align: center;\n}\n.topmenu {\n  border-bottom: solid 2px #707070;\n}\n\n.btnHight {\n  height: 35px;\n  font-size: 12px !important;\n  margin-top: 16px !important;\n}\n\n.removeredius {\n  width: 150px;\n  border-radius: 0 !important;\n  max-width: 100%;\n}\n\n.tokenList {\n  display: flex;\n  flex-wrap: wrap;\n  li {\n    color: #141518;\n    width: 103px;\n    border: solid 0.5px #e5e3dd;\n    margin: 0px 5px;\n    display: flex;\n    padding: 5px;\n    position: relative;\n    font-size: 10px;\n    text-align: center;\n    justify-content: center;\n    background-color: #fff;\n\n    svg {\n      color: #60be60;\n      right: 0;\n      bottom: 0px;\n      position: absolute;\n      font-size: 20px;\n    }\n    img {\n      width: 30px;\n    }\n  }\n}\n\n.chat-Box {\n  border: solid 0.5px #e5e3dd;\n  padding: 15px;\n  height: 65vh;\n  overflow-y: scroll;\n  .right-Box {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 25px;\n    div {\n      position: relative;\n      border-radius: 9px;\n      // box-shadow: 0 1.5px 3px 0 rgb(0 0 0 / 16%);\n      background-image: linear-gradient(to bottom, #c04848, #480048);\n      padding: 15px;\n      max-width: 500px;\n      min-width: 100px;\n      font-size: 15px;\n      color: #fff;\n      span {\n        position: absolute;\n        font-size: 11px;\n        color: #000;\n        right: 0;\n        bottom: -25px;\n      }\n    }\n  }\n  .left-Box {\n    display: flex;\n    justify-content: flex-start;\n    margin-bottom: 25px;\n    div {\n      position: relative;\n      border-radius: 9px;\n      box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);\n      background-color: #fff;\n      padding: 15px;\n      max-width: 500px;\n      min-width: 100px;\n      font-size: 15px;\n      color: #707070;\n      span {\n        position: absolute;\n        font-size: 11px;\n        color: #000;\n        right: 0;\n        bottom: -25px;\n      }\n    }\n  }\n}\n.userimg {\n  width: 100px;\n  height: 100px;\n  margin: auto;\n  border-radius: 50%;\n}\n\n.p.MuiFormHelperText-root.MuiFormHelperText-contained.Mui-error {\n  margin-left: 0px !important;\n}\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}","@media (max-width: 1640px) {\n  .tokenList li {\n    width: 101px;\n  }\n}\n@media (max-width: 1440px) {\n  .tokenList li {\n    width: 85px;\n  }\n}\n@media (max-width: 1366px) {\n  .tokenList li {\n    width: 80px;\n  }\n}\n@media (max-width: 1280px) {\n  .tokenList li {\n    width: 75px;\n  }\n}\n@media (max-width: 1024px) {\n  .tokenList li {\n    width: 75px;\n    margin-bottom: 5px;\n  }\n}\n@media (max-width: 991px) {\n}\n@media (max-width: 767px) {\n  .tokenList li {\n    width: 67px;\n  }\n  .imgWidth {\n    max-width: 100%;\n  }\n}\n.MuiFormHelperText-contained {\n  margin-left: 0px;\n  margin-right: 14px;\n}\n","$spaceamounts: (0,5, 10, 15, 20, 25, 30, 35, 40, 45, 50);\n$sides: (top, bottom, left, right);\n\n@each $space in $spaceamounts {\n  @each $side in $sides {\n    .m-#{str-slice($side, 0, 1)}-#{$space} {\n      margin-#{$side}: #{$space}px !important;\n    }\n    .m-#{$space} {\n      margin: #{$space}px !important;\n    }\n\n    .p-#{str-slice($side, 0, 1)}-#{$space} {\n      padding-#{$side}: #{$space}px !important;\n    }\n    .p-#{$space} {\n      padding: #{$space}px !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
